import PropTypes from "prop-types";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";

import Modal from "../Modal";

import warning from "@public/icons/warning.svg";

WarningModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  error: PropTypes.string,
};

const defaultProps = {
  visible: false,
  onCancel: () => {},
  error: "",
};

export default function WarningModal({ visible, onCancel, error }) {
  const { t } = useTranslation("errors");

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      closable
      className="warning-modal"
    >
      <div className="warning-modal__wrapper">
        <Image alt="warning" src={warning} width={48} height={48} />
        <p className="warning-modal__wrapper--warning">{t("warning")}</p>
        <p className="warning-modal__wrapper--error warning-modal__wrapper--text">
          {t(error)}
        </p>
        <p className="warning-modal__wrapper--text">
          {t("pleaseChooseAnotherRoom")}
        </p>
      </div>
    </Modal>
  );
}

WarningModal.defaultProps = defaultProps;
